




































































import { PropType } from '@nuxtjs/composition-api'
export const COLORS = Object.freeze(['primary'])
export const SIZES = Object.freeze(['medium', 'inner-label'])

export default {
  name: 'DSwitch',
  props: {
    value: [String, Number, Boolean, Function, Object, Array, Symbol],
    trueValue: {
      type: [String, Boolean],
      default: true
    },
    falseValue: {
      type: [String, Boolean],
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator(v) {
        return SIZES.includes(v)
      }
    },
    color: {
      type: String,
      default: 'primary',
      validator(v) {
        return COLORS.includes(v)
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    leftLabel: {
      type: Boolean,
      default: false
    },
    isAnimationWaiting: {
      type: Boolean,
      default: false
    },
    innerLabel: {
      type: Object as PropType<{ onLabel: string; offLabel: string }>,
      default: () => null,
      validator: v => {
        // nullなら許容
        if (!v) {
          return true
        }

        const properties = ['onLabel', 'offLabel']
        return properties.every(p => !!v[p])
      }
    },
    // NOTE: スイッチのアニメーションを即時発火したくないときに使用
    isPreventDefault: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        if (this.isAnimationWaiting) {
          // トグルのアニメーション分待つ
          setTimeout(() => this.$emit('input', val), 200)
        } else {
          this.$emit('input', val)
        }
      }
    }
  },
  methods: {
    onClick(e) {
      if (!this.isPreventDefault) {
        return
      }

      e.preventDefault()
      if (this.innerValue === this.trueValue) {
        this.innerValue = this.falseValue
      } else {
        this.innerValue = this.trueValue
      }
    }
  }
}
